import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "items-center" }
const _hoisted_2 = { class: "flex justify-between container w-full p-4" }
const _hoisted_3 = { class: "md:w-full h-auto bg-background dark:bg-backgroundDark rounded-md pt-2" }
const _hoisted_4 = { class: "flex flex-auto px-4 py-10" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "flex flex-col ml-4" }
const _hoisted_7 = { class: "flex items-center justify-center mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ps_label_header_6 = _resolveComponent("ps-label-header-6")!
  const _component_ps_label_title_3 = _resolveComponent("ps-label-title-3")!
  const _component_ps_label = _resolveComponent("ps-label")!
  const _component_ps_button = _resolveComponent("ps-button")!
  const _component_ps_modal = _resolveComponent("ps-modal")!
  const _component_ps_loading_dialog = _resolveComponent("ps-loading-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ps_modal, {
      ref: "psmodal",
      isClickOut: false,
      line: "hidden"
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_ps_label_header_6, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.offlineProvider.offlinePayment.data?.message), 1)
            ]),
            _: 1
          })
        ])
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offlineProvider.offlinePayment.data.offlinePayment, (offline) => {
              return (_openBlock(), _createElementBlock("div", {
                key: offline.id
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", null, [
                    _createElementVNode("img", {
                      alt: "Placeholder",
                      width: "300px",
                      height: "300px",
                      class: "w-18 mx-auto h-18",
                      src: _ctx.offlineProvider.imageUrl(offline ? offline.defaultIcon.imgPath : '',2) ,
                      onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.offlineProvider.defaultCarImage && _ctx.offlineProvider.defaultCarImage(...args)))
                    }, null, 40, _hoisted_5)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_ps_label_title_3, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(offline ? offline.title : ''), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_ps_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(offline ? offline.description : ''), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_ps_button, {
            class: "text-center w-60 mx-auto",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.actionClicked('yes')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('offline_payment_modal__pay_offline')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_ps_button, {
            class: "text-center w-60 mx-auto ms-4",
            theme: "btn-second",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.psmodal.toggle(false)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('stripe_credit_card_modal__cancel')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_ps_loading_dialog, {
      ref: "psloading",
      isClickOut: false
    }, null, 512)
  ], 64))
}